module.exports = __webpack_public_path__ + "img/lunbo152.2ff7eee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo152.png
// module id = HMaz
// module chunks = 0